import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v0/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v0/dynamic-assets';

export class DynamicAssetService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}
  deleteAllGeometryVolumeCellGrid(
    params: types.DeleteAllGeometryVolumeCellGridParameters,
  ): Promise<types.SuccessResponse> {
    throw new Error('Method not implemented.');
  }

  async deleteOneGeometryVolumeCellGrid(
    params: types.DeleteOneGeometryVolumeCellGridParameters,
  ): Promise<types.SuccessResponse> {
    return (
      await this.axios.delete(
        `/asset/dynamicasset/${params.path.assetId}/volume/${params.path.volumeId}`,
      )
    ).data;
  }
  async getDynamicAsset(
    params: types.GetDynamicAssetParameters,
  ): Promise<types.DynamicAssetResponse> {
    return (await this.axios.get(`/asset/dynamicasset/${params.path.id}`)).data;
  }
  async saveDynamicAsset({
    body,
  }: types.SaveDynamicAssetParameters): Promise<types.DynamicAssetResponse> {
    return (
      await this.axios.post(`/asset/dynamicasset/save`, {
        ...body,
      })
    ).data;
  }

  async delete({ body }: types.DeleteParameters): Promise<types.SuccessResponse> {
    return (
      await this.axios.post(`/asset/dynamicasset/delete`, {
        ...body,
      })
    ).data;
  }

  async calculateVolume({
    path,
    body,
  }: types.CalculateVolumeParameters): Promise<types.CalculateVolumeResponse> {
    return (
      await this.axios.post(`/asset/dynamicasset/${path.id}/volume`, {
        ...body,
      })
    ).data;
  }

  async putFileVersionTransform(
    params: types.PutFileVersionTransformParameters,
  ): Promise<types.SuccessResponse> {
    return (
      await this.axios.put(
        `/asset/dynamicasset/${params.path.dynamicAssetId}/file-version/${params.path.fileVersionId}/transform`,
        {
          ...params.body,
        },
      )
    ).data;
  }

  async fetchVolumeModelUrls(
    params: types.FetchVolumeModelUrlsParameters,
  ): Promise<common.DownloadUrlArrayResponse> {
    return (
      await this.axios.get(
        `/asset/dynamicasset/${params.path.assetId}/volume/${params.path.volumeId}/model-urls`,
      )
    ).data;
  }

  async getDxfSignedUrlV1(
    params: types.GetDxfSignedUrlV1Parameters,
  ): Promise<common.DownloadDxfURLResponse> {
    return (
      await this.axios.get(`/asset/dynamicasset/get-dxf-signed-url-v1`, { params: params.query })
    ).data;
  }

  async createSkyMapInformationModel(
    params: types.CreateSkyMapInformationModelParameters,
  ): Promise<void> {
    await this.axios.post(`/asset/dynamicasset/${params.path.id}/skymap-information-model`, {
      ...params.body,
    });
  }

  async updateSkyMapInformationModel(
    params: types.UpdateSkyMapInformationModelParameters,
  ): Promise<void> {
    await this.axios.put(`/asset/dynamicasset/${params.path.id}/skymap-information-model`, {
      ...params.body,
    });
  }
}
